import React from 'react';
import Script from 'next/script';
import { getStaticProps as getStaticPropsMethod } from '@/utils/page/ssr-pages-handler';
import { wrapper } from 'store';
import MetaData from '@/bit/core/core.meta-data';
import Page from '@/components/pageLayout';
import { grid } from '@/constants/grid';
import { URL_SEO, PATH_NAME } from '@/constants/pages/recovery-account';
import AccountForm from '@/containers/accountForm';
import { RECAPTCHA_KEY } from '@/constants/constant';
import { STEPS } from '@/constants/account';
import useAccountForm from '@/hooks/useAccountForm';

const RecoveryAccount = ({ seoInfo }) => {
  const { handleSubmit, control, step, loading, resetField } = useAccountForm({
    initStep: STEPS.RECOVERY_ACCOUNT,
  });

  return (
    <>
      <Script
        src={`https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`}
        strategy="lazyOnload"
      />
      <MetaData seoInfo={seoInfo} />
      <Page>
        <div className="form-layout container">
          <form className="row" onSubmit={handleSubmit}>
            <div className="col-lg-8 col-sm-7 col-xs-12 col-form-fields">
              <AccountForm step={step} control={control} loading={loading} resetField={resetField}/>
            </div>
          </form>
        </div>
      </Page>
      <style jsx>
        {`
          .form-layout {
            margin-top: 36px;
          }

          @media screen and (min-width: ${grid.breakpoint_sm}px) {
            .col-form-fields {
              grid-column-start: 4;
              grid-column-end: 10;
            }
          }
          @media screen and (min-width: ${grid.breakpoint_lg}px) {
            .col-form-fields {
              grid-column-start: 5;
              grid-column-end: 9;
            }
          }
        `}
      </style>
    </>
  );
};
export default RecoveryAccount;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, '', 2, {
    pathname: PATH_NAME,
    orionAlias: '',
    seoLocation: URL_SEO,
    headerLocation: '/',
    layoutInfo: '',
  });
});
